export const LOCATION_STATUS_FILTER = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const

export type LocationStatusFilter =
  (typeof LOCATION_STATUS_FILTER)[keyof typeof LOCATION_STATUS_FILTER]

/** Province `type` values returned by master-service. */
export const PROVINCE_TYPE = {
  PROVINCE: 'province',
  TINH: 'tinh',
  MUNICIPALITY: 'municipality',
  CENTRAL_CITY: 'thanh_pho_trung_uong',
  CITY_UNDER_PROVINCE: 'thanh_pho_truc_thuoc_tinh',
} as const
